import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { TranslationService } from '../services/translation-service';
import { TranslateService } from '@ngx-translate/core';
import { standardToLangMap } from '../helpers/i18n/lang-mappers';

function findLang(route: ActivatedRouteSnapshot): string | null {
  let current: ActivatedRouteSnapshot | null = route;

  while (current) {
    const lang = current.paramMap.get('lang');

    if (lang) {
      return lang;
    }

    current = current.parent;
  }

  return null;
}

export const featureTranslationResolver: ResolveFn<boolean> = (route) => {
  const translation = inject(TranslationService);

  // Child service (feature)
  const featureTranslate = inject(TranslateService);

  // Root service
  const rootTranslate = translation.getRootTranslate();

  const urlLang = findLang(route);

  let lang = translation.currentLang(rootTranslate);

  if (urlLang && standardToLangMap[urlLang]) {
    lang = standardToLangMap[urlLang];
  }

  return translation.useAll(rootTranslate, featureTranslate, lang);
};
